const testimonials = [
  {
    name: "Carlos M.",
    location: "Weston, FL",
    rating: 5,
    text: "My mother in Bogota needed emergency surgery and I had to fly out of FLL in four days. I pulled my passport from the safe and it had expired two months earlier. I signed up with Fast Passport Center Monday morning, shipped everything from the FedEx on Weston Road, and had my renewed passport Wednesday afternoon. I was on my flight to Medellin Thursday morning. They understood the urgency of a family emergency and delivered exactly what they promised.",
    service: "Passport Renewal",
  },
  {
    name: "Maria L.",
    location: "Weston, FL",
    rating: 5,
    text: "We are a Colombian family in Weston and travel to Medellin at least twice a year to see my parents. This January I was booking our April tickets and checked my daughter's passport — expired six months ago. I panicked because we had already bought the tickets. Fast Passport Center handled her child passport renewal in five business days. The process was clear, the instructions were exact, and we made our trip without any issues. I have recommended them to three other Colombian families in our neighborhood.",
    service: "Child Passport",
  },
  {
    name: "Robert K.",
    location: "Weston, FL",
    rating: 5,
    text: "Our family of five was booked on a Caribbean cruise departing Port Everglades in eight days. I casually checked our passports the weekend before we were supposed to drive to the port and discovered both of my kids' passports had expired over the summer. I thought our $4,000 cruise was completely lost. Fast Passport Center saved us. They processed both child passports in three days and we made our sailing with a day to spare. I cannot express how grateful we are.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function WestonTestimonialsSection() {
  return (
    <section id="testimonials" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Weston Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Weston, Sunrise, Plantation, and western Broward County residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}